/* ZSportsTech — section-filter.js
   Cricket IQ Hub: category-chip filtering + guide search.
   Scoped to #sc-iqhero (chips/search) and the §03 library grid (#sc-iqlib).
   Vanilla, namespaced, reduced-motion aware.
   Maps to → assets/section-filter.js in the Shopify theme.

   In Liquid this is replaced by native behaviour:
     • chips → tag links  (/blogs/cricket-iq/tagged/<tag>)
     • search → native blog search
   Here it is a working client-side placeholder. It degrades gracefully
   when the §03 grid is not on the page (e.g. the section previewed alone).
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var hero = document.getElementById('sc-iqhero');
  if (!hero) return;

  var chips    = Array.prototype.slice.call(hero.querySelectorAll('.category-chip'));
  var search   = hero.querySelector('.sc-iqhero__input');
  var grid     = document.getElementById('sc-iqlib-grid'); /* §03 grid, may be absent */
  var emptyMsg = document.getElementById('sc-iqlib-empty'); /* §03 empty nudge, may be absent */

  var activeTag = 'all';

  function cards() {
    return grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-tags]')) : [];
  }

  /* A card matches when its tags include the active tag (or tag = all)
     AND its title/tags contain the search query. */
  function apply() {
    var q = (search && search.value ? search.value : '').trim().toLowerCase();
    var shown = 0;

    cards().forEach(function (card) {
      var tags  = (card.getAttribute('data-tags')  || '').toLowerCase();
      var title = (card.getAttribute('data-title') || card.textContent || '').toLowerCase();

      var tagOk    = activeTag === 'all' || tags.split(/\s+/).indexOf(activeTag) !== -1;
      var searchOk = !q || title.indexOf(q) !== -1 || tags.indexOf(q) !== -1;
      var ok       = tagOk && searchOk;

      card.hidden = !ok;
      if (ok) shown++;
    });

    if (emptyMsg) emptyMsg.hidden = (cards().length === 0) || (shown > 0);
  }

  /* Chip click → set active tag + repaint */
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      activeTag = chip.getAttribute('data-tag') || 'all';
      chips.forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('category-chip--active', on);
        c.setAttribute('aria-pressed', String(on));
      });
      apply();
    });
  });

  /* Search input → debounced repaint */
  if (search) {
    var t = null;
    search.addEventListener('input', function () {
      window.clearTimeout(t);
      t = window.setTimeout(apply, 120);
    });
    /* Prevent the placeholder <form> from navigating in the static build */
    var form = search.closest('form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
  }

  apply();
}());

/* ───────────────────────────────────────────────────
   Catalogue (Products) — category filter chips.
   Scoped to #sc-cathead (chips) + the category sections (.sc-cat) in
   #sc-catbody. Each chip maps to a category; the active chip shows only
   that category (All shows every section). The choice is reflected in the
   URL hash (#cricket-bats …) so it is shareable / restored on load.

   In Liquid each chip becomes a collection link (/collections/<handle>);
   here it is a working client-side placeholder. Degrades gracefully when
   the category sections are not on the page.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var head = document.getElementById('sc-cathead');
  var body = document.getElementById('sc-catbody');
  if (!head) return;

  var chips    = Array.prototype.slice.call(head.querySelectorAll('.sc-cathead__chip'));
  var sections = body ? Array.prototype.slice.call(body.querySelectorAll('.sc-cat')) : [];
  var search   = document.getElementById('sc-cathead-q');
  var foot     = document.getElementById('sc-catbody-foot');
  var footDefault = foot ? foot.textContent : '';
  var activeCat = 'all';

  function setChip(cat) {
    chips.forEach(function (c) {
      var on = (c.getAttribute('data-cat') || 'all') === cat;
      c.classList.toggle('sc-cathead__chip--active', on);
      c.setAttribute('aria-pressed', String(on));
    });
  }

  /* Filter tiles by the search query AND the active category. A section is hidden
     when its category is filtered out, or when no tile in it matches the query.
     The trailing divider of the LAST visible section is hidden so a filtered view
     never ends on a rule. */
  function apply() {
    var q = (search && search.value ? search.value : '').trim().toLowerCase();
    var visible = [];
    var total = 0;

    sections.forEach(function (sec) {
      var catOk = activeCat === 'all' || sec.getAttribute('data-category') === activeCat;
      var shown = 0;
      Array.prototype.forEach.call(sec.querySelectorAll('.product-tile'), function (tile) {
        var nameEl = tile.querySelector('.product-tile__name');
        var specEl = tile.querySelector('.product-tile__spec');
        var text = ((nameEl ? nameEl.textContent : '') + ' ' + (specEl ? specEl.textContent : '')).toLowerCase();
        var ok = !q || text.indexOf(q) !== -1;
        tile.hidden = !ok;
        if (ok) shown++;
      });
      var secOk = catOk && shown > 0;
      sec.hidden = !secOk;
      if (secOk) { visible.push(sec); total += shown; }
    });

    visible.forEach(function (sec, i) {
      var div = sec.querySelector('.sc-cat__div');
      if (div) div.hidden = (i === visible.length - 1);
    });

    if (foot) {
      if (q) {
        foot.textContent = total === 0
          ? 'No products match “' + search.value.trim() + '”'
          : total + (total === 1 ? ' product' : ' products') + ' for “' + search.value.trim() + '”';
      } else {
        foot.textContent = footDefault;
      }
    }
  }

  function isValidCat(cat) {
    if (cat === 'all') return true;
    return sections.some(function (s) { return s.getAttribute('data-category') === cat; });
  }

  function selectCat(cat, pushHash) {
    if (!isValidCat(cat)) cat = 'all';
    activeCat = cat;
    setChip(cat);
    apply();
    if (pushHash) {
      if (cat === 'all') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } else if (window.location.hash.slice(1) !== cat) {
        history.replaceState(null, '', '#' + cat);
      }
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      selectCat(chip.getAttribute('data-cat') || 'all', true);
    });
  });

  /* Search input → debounced repaint; keep submit on-page */
  if (search) {
    var t = null;
    search.addEventListener('input', function () { window.clearTimeout(t); t = window.setTimeout(apply, 110); });
    var form = search.closest('form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
  }

  /* Restore from URL hash (shareable) + react to manual hash changes */
  window.addEventListener('hashchange', function () {
    selectCat(window.location.hash.slice(1) || 'all', false);
  });

  selectCat(window.location.hash.slice(1) || 'all', false);
}());
